import {
  computed,
  IObservableArray,
  makeAutoObservable,
  observable,
} from "mobx";
import Fuse from "fuse.js";
import { IllustrationImageDTOWithNameAndAuthor } from "../DTO/Image/TaskImageDTO";
import { IllustrationApi } from "../DTO/ServerResponseType/Illustration/Illustration";
import illustrationServerClient from "../ServerClients/IllustrationServerClient";
import appStore from "./AppStore";

const fuseOptions = {
  isCaseSensitive: false,
  shouldSort: false,
  keys: ["illustrationName"],
};

export class IllustrationsStore {
  /**
   * All illustrations
   */
  public illustrations: IObservableArray<IllustrationImageDTOWithNameAndAuthor> =
    observable.array([]);

  /**
   * Fuse for search illustrations by name
   */
  public fuse: Fuse<IllustrationImageDTOWithNameAndAuthor> = new Fuse(
    this.illustrations,
    fuseOptions
  );
  public searchIllustrationNamePattern: string = "";

  /**
   * Open or close dialog modal to view all illustrations and manage them
   */
  public showManageIllustrations: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  public onManageModalOpen = () => {
    this.showManageIllustrations = true;
  };

  public onManageModalClose = () => {
    this.showManageIllustrations = false;
  };

  public onChangeSearchIllustrationNamePattern = (
    event: React.FormEvent<HTMLInputElement>
  ) => {
    this.searchIllustrationNamePattern = event.currentTarget.value;
  };

  @computed
  get searchedIllustrations(): IllustrationImageDTOWithNameAndAuthor[] {
    let searchedIllustrations: IllustrationImageDTOWithNameAndAuthor[] = [];

    if (this.searchIllustrationNamePattern !== "") {
      let fuseResult = this.fuse.search(this.searchIllustrationNamePattern);
      searchedIllustrations = fuseResult.map(({ item }) => item);
    } else searchedIllustrations = this.illustrations.toJSON();

    return searchedIllustrations;
  }

  pushIllustration = (illustration: IllustrationApi) => {
    this.illustrations.push(
      new IllustrationImageDTOWithNameAndAuthor(illustration)
    );

    this.fuse.setCollection(this.illustrations);
  };

  setIllustrations = (illustrations: IllustrationApi[]) => {
    this.illustrations.replace(
      Array.from(
        illustrations,
        (illustration) =>
          new IllustrationImageDTOWithNameAndAuthor(illustration)
      )
    );

    this.fuse.setCollection(this.illustrations);
  };

  deleteIllustration = (illustrationId: string) => {
    illustrationServerClient
      .sendToDeleteIllustrationAsync(illustrationId)
      .then(() => {
        this.illustrations.replace(
          this.illustrations.filter(
            (el: IllustrationImageDTOWithNameAndAuthor) =>
              el.imageId !== illustrationId
          )
        );
        appStore.taskStore.taskIllustrationsStore.deleteIllustrationByIllustrationId(
          illustrationId
        );
      });
  };

  public loadAllIllustrationsAsync = async (): Promise<
    IllustrationApi[] | never
  > => {
    return illustrationServerClient.sendToGetAllIllustrationsAsync();
  };
}
